import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnupshmpwb: FaireProductEntity = {
  token: "p_bnupshmpwb",
  type: "product",
  name: "O-Gi Fan Japanese Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/3c9f7213cc9c3ed08468fddd4e815aaf0b4bf31305e803a717978dedc991a3a0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb1449c4b54e91a53bb7fbd63c26545e1a13d58474266c627c28ac2a096aede1.jpeg",
    "https://cdn.faire.com/fastly/9e8dc604ab1e46e5f990a1dc7f8fee41a23f8b8916b95b0988084076d462fb7d.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these O-Gi Fan washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Sakura, Warlord, Origami, Maneki Neko, Japanese Foods, Origami Cranes, Ukiyo Mt. Fuji \nSpecifications\n\n * Type: Washi stickers \n * Design: O-Gi Fan \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:04.819Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
